import { Box, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons';

interface Component {
  _id: string;
  name: string;
  [key: string]: any;
}

interface TitleCellMainProps {
  record: Component;
  isExpanded: boolean;
}

export function TitleCellMain({ record, isExpanded }: TitleCellMainProps) {
  return (
    <Box 
      component="span" 
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        gap: '8px',
      }}
    >
      <Text maw={300} lineClamp={1}>{record.name}</Text>
      {isExpanded ? (
        <IconChevronDown size={13} stroke={1.5} fill='black' />
      ) : (
        <IconChevronDown size={13} stroke={1.5} fill='black' />
      )}
    </Box>
  );
} 